import "./entur.css";
import "./index.css";

import { AppShellStandalone } from "@entur-partner/app-shell-standalone";
import { registerMicroFrontend } from "@entur-partner/micro-frontend";
import { assertIsDefined } from "@entur-partner/util";
import { createRoot } from "react-dom/client";

import { App } from "@app/App.tsx";
import { decorateAuth0User } from "@utils/decorateAuth0User.ts";
import config from "@/config.ts";
import { initI18n } from "@/locales/i18n.ts";

const container = document.getElementById("root");
assertIsDefined(container, "Root container not found");
let root = createRoot(container);

registerMicroFrontend({
  microFrontendId: "AutomatOps",
  mount: (mountPoint, payload) => {
    initI18n(payload.language);
    root = createRoot(mountPoint);
    root.render(<App {...payload} />);
  },
  unmount: () => {
    root.unmount();
  }
});

// AppShellStandalone is used when the micro-frontend is run as a standalone application, not embedded in another application.
if (import.meta.env.VITE_APP_STANDALONE) {
  await import("@entur-partner/app-shell-standalone/styles.css");

  initI18n("nb");
  root.render(
    <AppShellStandalone
      clientId={config.auth0ClientId}
      domain={config.auth0Domain}
      audience={config.auth0Audience}
      getOrganisations={() => Promise.resolve([])}
      decorateUser={decorateAuth0User}
      environment={config.environment}
    >
      {(values) => {
        return <App {...values} />;
      }}
    </AppShellStandalone>
  );
}
